
import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import { Info, Users, ShieldCheck } from 'lucide-react';
import { Helmet } from 'react-helmet';

const About = () => {
  // JSON-LD structured data for Organization
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "TreguIm",
    "url": "https://treguim.org",
    "logo": "https://treguim.org/logo512.png",
    "sameAs": [
      "https://www.facebook.com/treguIm/",
      "https://www.instagram.com/treguim.org/"
    ],
    "description": "TreguIm është platforma më e madhe për blerjen dhe shitjen e produkteve të përdorura në Shqipëri.",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "Albania",
      "addressLocality": "Tirana"
    },
    "foundingDate": "2018"
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Helmet>
        <title>Rreth Nesh | TreguIm</title>
        <meta name="description" content="Mëso më shumë për TreguIm, platforma më e madhe për blerjen dhe shitjen e produkteve të përdorura në Shqipëri. Historia, misioni dhe vlerat tona." />
        <meta name="keywords" content="rreth treguim.org, rreth treguim, historia e treguim.org, misioni i treguim, shqipëri marketplace" />
        <meta property="og:title" content="Rreth Nesh | TreguIm" />
        <meta property="og:description" content="TreguIm është platforma më e madhe për blerjen dhe shitjen e produkteve të përdorura në Shqipëri." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://treguim.org/about" />
        <meta property="og:image" content="https://treguim.org/logo512.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Rreth Nesh | TreguIm" />
        <meta name="twitter:description" content="Mëso më shumë për TreguIm, platforma më e madhe për blerjen dhe shitjen e produkteve në Shqipëri." />
        <link rel="canonical" href="https://treguim.org/about" />
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
      </Helmet>
      
      <Navbar />
      
      <main className="flex-grow pt-16">
        {/* Hero section */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-brand-50 to-white"></div>
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
            <div className="text-center max-w-3xl mx-auto">
              <h1 className="text-3xl md:text-4xl font-bold mb-6">Rreth Nesh</h1>
              <p className="text-lg text-gray-600 mb-8">
                TreguIm është platforma më e madhe për blerjen dhe shitjen e produkteve të përdorura në Shqipëri. 
                Ne i lidhim blerësit dhe shitësit nga i gjithë vendi për të krijuar një treg të sigurt dhe efektiv.
              </p>
            </div>
          </div>
        </section>
        
        {/* Mission section */}
        <section className="py-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col md:flex-row items-center gap-12">
              <div className="md:w-1/2">
                <img 
                  src="https://images.unsplash.com/photo-1556745757-8d76bdb6984b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2073&q=80" 
                  alt="Ekipi i Tregu.al duke punuar në platformën e tregtisë online" 
                  className="rounded-xl shadow-lg"
                  width="2073"
                  height="1380"
                  loading="lazy"
                />
              </div>
              <div className="md:w-1/2">
                <h2 className="text-2xl font-bold mb-4">Misioni ynë</h2>
                <p className="text-gray-600 mb-6">
                  Misioni ynë është të krijojmë një platformë të besueshme dhe të lehtë për t'u përdorur ku shqiptarët 
                  mund të blejnë dhe shesin produkte, duke zvogëluar mbetjet dhe duke nxitur ekonominë qarkulluese.
                </p>
                <p className="text-gray-600 mb-6">
                  Ne besojmë në ndërtimin e një komuniteti ku produktet e dikujt që nuk janë më të nevojshme mund të 
                  gjejnë një shtëpi të re, duke zgjatur ciklin e jetës së produktit dhe duke ulur ndikimin në mjedis.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8">
                  <div className="text-center p-4">
                    <div className="bg-brand-50 text-brand-500 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
                      <Users size={24} />
                    </div>
                    <h3 className="font-medium">500K+</h3>
                    <p className="text-sm text-gray-500">Përdorues aktivë</p>
                  </div>
                  <div className="text-center p-4">
                    <div className="bg-brand-50 text-brand-500 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
                      <ShieldCheck size={24} />
                    </div>
                    <h3 className="font-medium">1M+</h3>
                    <p className="text-sm text-gray-500">Transaksione të sigurta</p>
                  </div>
                  <div className="text-center p-4">
                    <div className="bg-brand-50 text-brand-500 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
                      <Info size={24} />
                    </div>
                    <h3 className="font-medium">2018</h3>
                    <p className="text-sm text-gray-500">Themeluar</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default About;
